import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, Star, Award, Clock } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden bg-navy" data-id="element-77">
      {/* Background Image with Parallax Effect */}
      <div className="absolute inset-0 z-0 opacity-40 mix-blend-overlay" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed'
    }} data-id="element-78" />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-navy via-navy/80 to-transparent" data-id="element-79" />

      <div className="container relative z-20 px-4 md:px-6 py-12 md:py-24 text-center" data-id="element-80">
        <div className="max-w-4xl mx-auto space-y-8" data-id="element-81">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight leading-tight" data-id="element-82">
            Crystal-Clear Windows.
            <span className="block text-gold mt-2" data-id="element-83">
              Arizona Sunshine Guaranteed.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto leading-relaxed" data-id="element-84">
            Professional residential & commercial window cleaning serving
            Phoenix, Gilbert & the East Valley. Experience the difference of a
            truly spotless view.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4" data-id="element-85">
            <Button variant="secondary" size="lg" className="w-full sm:w-auto min-w-[200px]" data-id="element-86">
              Get a Free Quote
            </Button>
            <Button variant="outline" size="lg" className="w-full sm:w-auto min-w-[200px]" data-id="element-87">
              Our Services
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="pt-12 flex flex-wrap justify-center gap-6 md:gap-12 text-white/90" data-id="element-88">
            <div className="flex items-center gap-2" data-id="element-89">
              <ShieldCheck className="h-5 w-5 text-gold" data-id="element-90" />
              <span className="text-sm md:text-base font-medium" data-id="element-91">
                Licensed & Insured
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-92">
              <Award className="h-5 w-5 text-gold" data-id="element-93" />
              <span className="text-sm md:text-base font-medium" data-id="element-94">
                Locally Owned
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-95">
              <Star className="h-5 w-5 text-gold" data-id="element-96" />
              <span className="text-sm md:text-base font-medium" data-id="element-97">
                5-Star Rated
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-98">
              <Clock className="h-5 w-5 text-gold" data-id="element-99" />
              <span className="text-sm md:text-base font-medium" data-id="element-100">
                Free Estimates
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}